var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitePatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_01_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_01_3",
    "data-name": "Icon 01 \\u2013 3",
    clipPath: "url(#clip-Icon_01_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4099",
    "data-name": "Group 4099",
    transform: "translate(-550.119 -593.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6330",
    "data-name": "Path 6330",
    d: "M568.643,634l-8.762,4.485L551.12,634",
    transform: "translate(0 -34.414)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6331",
    "data-name": "Path 6331",
    d: "M568.643,599.588l-8.762-5.854-8.761,5.854V610.13a.513.513,0,0,0,.513.513h16.5a.513.513,0,0,0,.513-.513Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4098",
    "data-name": "Group 4098",
    transform: "translate(557.231 604.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6332",
    "data-name": "Path 6332",
    d: "M593.164,665.8l2.182,1.117a1.025,1.025,0,0,0,.935,0l2.182-1.117",
    transform: "translate(-593.164 -665.804)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6333",
    "data-name": "Path 6333",
    d: "M589.508,629.347v-3.353h-8.97v3.353",
    transform: "translate(-25.142 -27.571)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_703",
    "data-name": "Line 703",
    x2: 5.072,
    transform: "translate(557.345 600.044)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_704",
    "data-name": "Line 704",
    x2: 5.072,
    transform: "translate(557.345 601.376)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6334",
    "data-name": "Path 6334",
    d: "M572.7,687.973v-1.614a29.879,29.879,0,0,1-14.86,0v1.614Z",
    transform: "translate(-5.388 -78.161)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitePatient);
export default __webpack_public_path__ + "static/media/invite-patient.0495fb5c456dc2a1096f6fd89d5f24af.svg";
export { ForwardRef as ReactComponent };